import styled from "styled-components";
import { FlexBox } from "@brg/ui";
import { Input } from "@brg/input";
import { LayoutConst } from "core";
import { RectangularButtonHollow, RectangularButtonFilled } from "shared/components/buttons";

export const PageContainer = styled.div`
  width: 100%;
  max-width: ${LayoutConst.projectContainer.l}px;
  margin: 0 auto;
  padding: 24px 0;
  position: relative;
  overflow: visible;
  
  
`;

export const PageTitle = styled.h1`
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.86px;
  color: #151514;
  margin: 0 0 8px 0;
  
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 32px;
    line-height: 38px;
  }
`;

export const PageDescription = styled.p`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #909090;
  margin: 0 0 32px 0;
`;

export const FiltersCard = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
  position: relative;
  overflow: visible;
`;

export const FiltersTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #151514;
  margin: 0 0 20px 0;
`;

export const FiltersRow = styled(FlexBox)`
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  position: relative;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: column;
  }
`;

export const FilterField = styled.div`
  flex: 1;
  position: relative;
  min-width: 200px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: 100%;
  }
  
  @media (max-width: 992px) {
    &:has(.react-datetime-picker__calendar--open) {
      z-index: 1001;
    }
  }
  
  @media (min-width: 992px) {
    &:has(.react-datetime-picker__calendar--open) {
      z-index: 1001;
    }
  }
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  
  .react-datetime-picker {
    max-width: 100% !important;
  }
  
  .react-datetime-picker__wrapper {
    border: transparent;
    border-radius: 3px;
    padding: 0 12px;
    height: 48px;
    background: #F2F2F2;
  }
  
  .react-datetime-picker__inputGroup {
    flex: 1;
  }
  
  .react-datetime-picker__inputGroup__input {
    color: #151514;
    font-size: 17px;
    line-height: 22px;
  }
  
  .react-datetime-picker__button {
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }
  
  .react-datetime-picker__calendar-button {
    display: flex;
    align-items: center;
  }
  
  .react-calendar {
    z-index: 1000 !important;
  }
  
  .react-datetime-picker__calendar {
    z-index: 1000 !important;
  }
  
  @media (max-width: 992px) {
    z-index: 1000;
    
    .react-calendar {
      z-index: 1001 !important;
      position: absolute !important;
    }
    
    .react-datetime-picker__calendar {
      z-index: 1001 !important;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    .react-datetime-picker {
      max-width: 100% !important;
      width: 100% !important;
    }
  }
`;

export const FilterLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #909090;
  margin-bottom: 8px;
  white-space: nowrap;
`;

export const StyledDropdown = styled(Input.Dropdown)`
  width: 100%;
  position: relative;
  z-index: 1000;
  
  .brg-input__control {
    background-color: #F2F2F2 !important;
    border-color: transparent;
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
    
    &:hover {
      border-color: ${({ theme }) => theme?.dropdown?.borderFocusColor || theme?.dropdown?.borderColor || '#151514'} !important;
    }
  }
  
  .brg-input__single-value {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__placeholder {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#909090'} !important;
    opacity: 0.7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .brg-input__value-container {
    white-space: nowrap;
    overflow: hidden;
  }
  
  .brg-input__input-container {
    white-space: nowrap;
  }
  
  .brg-input__indicator svg path {
    fill: ${({ theme }) => theme?.dropdown?.arrow || theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__menu {
    background-color: #F2F2F2 !important;
    border-color: ${({ theme }) => theme?.dropdown?.borderColor || '#B6B6B5'} !important;
    z-index: 1001 !important;
  }
  
  .brg-input__option {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
    background-color: #F2F2F2 !important;
    position: relative;
    
    &:hover,
    &.brg-input__option--is-focused {
      background-color: #E5E5E5 !important;
    }
    
    svg {
      path {
        fill: #151514 !important;
      }
    }
  }
  
  .brg-input__option--is-selected {
    background-color: #E5E5E5 !important;
    
    svg {
      path {
        fill: #151514 !important;
      }
    }
  }
  
  .brg-input__indicator-separator {
    display: none;
  }
  
  .brg-input__dropdown-indicator svg path,
  .brg-input__clear-indicator svg path {
    fill: ${({ theme }) => theme?.dropdown?.arrow || theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__menu-notice {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
  }
`;

export const GroupSearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const GroupSearchInput = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 3px;
  border: transparent;
  padding: 0 16px;
  background: #F2F2F2;
  color: #151514;
  font-size: 17px;
  line-height: 22px;
  outline: none;

  &::placeholder {
    color: #909090;
  }
`;

export const GroupSearchList = styled.div`
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  background: #F2F2F2;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1001;
`;

export const GroupSearchItem = styled.button<{ isSelected?: boolean; isDisabled?: boolean }>`
  width: 100%;
  max-width: 100%;
  display: block;
  text-align: left;
  padding: 10px 12px;
  border: none;
  background: ${({ isSelected }) => (isSelected ? '#E5E5E5' : 'transparent')};
  color: #151514;
  font-size: 15px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${({ isDisabled }) => (isDisabled ? 'transparent' : '#E5E5E5')};
  }
`;

export const SelectedGroupsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;


export const SelectedGroupTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #E5E5E5;
  border-radius: 12px;
  font-size: 13px;
  line-height: 16px;
  color: #151514;
  max-width: 200px;
  min-width: 0;
`;

export const SelectedGroupText = styled.span`
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

export const SelectedGroupRemove = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  color: #151514;
  font-size: 14px;
  line-height: 14px;
  padding: 0;
`;

export const TagSelectButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: transparent;
  border-radius: 3px;
  background: #F2F2F2;
  color: #151514;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &:hover {
    border-color: #151514;
  }
  
  &:focus {
    outline: none;
    border-color: #151514;
  }
`;

export const FilterButtons = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterButtonsLeft = styled(FlexBox)`
  justify-content: start;
  gap: 12px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const RetakeCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  .common-checkbox {
    width: auto !important;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    justify-content: flex-start;
    
    .common-checkbox {
      width: 100% !important;
    }
  }
`;

export const StyledResetButton = styled(RectangularButtonHollow)<{ height?: number }>`
  height: ${({ height }) => height ? `${height}px` : '48px'} !important;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const StyledApplyButton = styled(RectangularButtonFilled)<{ height?: number }>`
  height: ${({ height }) => height ? `${height}px` : '48px'} !important;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const TableContainer = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
  
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #F2F2F2;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #BFBFBF;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #A0A0A0;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #BFBFBF #F2F2F2;
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const TableHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #CDCDCD;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  color: #151514;
  white-space: nowrap;
  background: #F2F2F2;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableCell = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #E5E5E5;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #151514;
`;

export const GroupsTableCell = styled(TableCell)`
  max-width: 180px;
  width: 180px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  background: #99E599;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const GroupsTooltipStyle = styled.div`
  .groups-tooltip {
    background-color: #353A3E;
    color: #FEFEFE;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    line-height: 16px;
    max-width: 300px;
    z-index: 10000;
    
    div {
      color: #FEFEFE;
      margin-top: 4px;
      
      &:first-child {
        margin-top: 0;
      }
    }
  }
`;
import styled from "styled-components";
import { FlexBox } from "@brg/ui";
import { Input } from "@brg/input";
import { LayoutConst } from "core";
import { RectangularButtonHollow, RectangularButtonFilled } from "shared/components/buttons";

export const PageContainer = styled.div`
  width: 100%;
  max-width: ${LayoutConst.projectContainer.l}px;
  margin: 0 auto;
  padding: 24px 0;
  position: relative;
  overflow: visible;
  
  
`;

export const PageTitle = styled.h1`
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.86px;
  color: #151514;
  margin: 0 0 8px 0;
  
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 32px;
    line-height: 38px;
  }
`;

export const PageDescription = styled.p`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: #909090;
  margin: 0 0 32px 0;
`;

export const FiltersCard = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
  position: relative;
  overflow: visible;
`;

export const FiltersTitle = styled.h2`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #151514;
  margin: 0 0 20px 0;
`;

export const FiltersRow = styled(FlexBox)`
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  position: relative;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    flex-direction: column;
  }
`;

export const FilterField = styled.div`
  flex: 1;
  position: relative;
  min-width: 200px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    max-width: 100%;
  }
  
  @media (max-width: 992px) {
    &:has(.react-datetime-picker__calendar--open) {
      z-index: 1001;
    }
  }
  
  @media (min-width: 992px) {
    &:has(.react-datetime-picker__calendar--open) {
      z-index: 1001;
    }
  }
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  
  .react-datetime-picker {
    max-width: 100% !important;
  }
  
  .react-datetime-picker__wrapper {
    border: transparent;
    border-radius: 3px;
    padding: 0 12px;
    height: 48px;
    background: #F2F2F2;
  }
  
  .react-datetime-picker__inputGroup {
    flex: 1;
  }
  
  .react-datetime-picker__inputGroup__input {
    color: #151514;
    font-size: 17px;
    line-height: 22px;
  }
  
  .react-datetime-picker__button {
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
  }
  
  .react-datetime-picker__calendar-button {
    display: flex;
    align-items: center;
  }
  
  .react-calendar {
    z-index: 1000 !important;
  }
  
  .react-datetime-picker__calendar {
    z-index: 1000 !important;
  }
  
  @media (max-width: 992px) {
    z-index: 1000;
    
    .react-calendar {
      z-index: 1001 !important;
      position: absolute !important;
    }
    
    .react-datetime-picker__calendar {
      z-index: 1001 !important;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    .react-datetime-picker {
      max-width: 100% !important;
      width: 100% !important;
    }
  }
`;

export const FilterLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #909090;
  margin-bottom: 8px;
  white-space: nowrap;
`;

export const StyledDropdown = styled(Input.Dropdown)`
  width: 100%;
  position: relative;
  z-index: 1000;
  
  .brg-input__control {
    background-color: #F2F2F2 !important;
    border-color: transparent;
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
    
    &:hover {
      border-color: ${({ theme }) => theme?.dropdown?.borderFocusColor || theme?.dropdown?.borderColor || '#151514'} !important;
    }
  }
  
  .brg-input__single-value {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__placeholder {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#909090'} !important;
    opacity: 0.7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .brg-input__value-container {
    white-space: nowrap;
    overflow: hidden;
  }
  
  .brg-input__input-container {
    white-space: nowrap;
  }
  
  .brg-input__indicator svg path {
    fill: ${({ theme }) => theme?.dropdown?.arrow || theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__menu {
    background-color: #F2F2F2 !important;
    border-color: ${({ theme }) => theme?.dropdown?.borderColor || '#B6B6B5'} !important;
    z-index: 1001 !important;
  }
  
  .brg-input__option {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
    background-color: #F2F2F2 !important;
    position: relative;
    
    &:hover,
    &.brg-input__option--is-focused {
      background-color: #E5E5E5 !important;
    }
    
    svg {
      path {
        fill: #151514 !important;
      }
    }
  }
  
  .brg-input__option--is-selected {
    background-color: #E5E5E5 !important;
    
    svg {
      path {
        fill: #151514 !important;
      }
    }
  }
  
  .brg-input__indicator-separator {
    display: none;
  }
  
  .brg-input__dropdown-indicator svg path,
  .brg-input__clear-indicator svg path {
    fill: ${({ theme }) => theme?.dropdown?.arrow || theme?.dropdown?.textColor || '#151514'} !important;
  }
  
  .brg-input__menu-notice {
    color: ${({ theme }) => theme?.dropdown?.textColor || '#151514'} !important;
  }
`;

export const GroupSearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const GroupSearchInput = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 3px;
  border: transparent;
  padding: 0 16px;
  background: #F2F2F2;
  color: #151514;
  font-size: 17px;
  line-height: 22px;
  outline: none;

  &::placeholder {
    color: #909090;
  }
`;

export const GroupSearchList = styled.div`
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  background: #F2F2F2;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1001;
`;

export const GroupSearchItem = styled.button<{ isSelected?: boolean; isDisabled?: boolean }>`
  width: 100%;
  max-width: 100%;
  display: block;
  text-align: left;
  padding: 10px 12px;
  border: none;
  background: ${({ isSelected }) => (isSelected ? '#E5E5E5' : 'transparent')};
  color: #151514;
  font-size: 15px;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${({ isDisabled }) => (isDisabled ? 'transparent' : '#E5E5E5')};
  }
`;

export const SelectedGroupsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;


export const SelectedGroupTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: #E5E5E5;
  border-radius: 12px;
  font-size: 13px;
  line-height: 16px;
  color: #151514;
  max-width: 200px;
  min-width: 0;
`;

export const SelectedGroupText = styled.span`
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

export const SelectedGroupRemove = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  color: #151514;
  font-size: 14px;
  line-height: 14px;
  padding: 0;
`;

export const TagSelectButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: transparent;
  border-radius: 3px;
  background: #F2F2F2;
  color: #151514;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &:hover {
    border-color: #151514;
  }
  
  &:focus {
    outline: none;
    border-color: #151514;
  }
`;

export const FilterButtons = styled(FlexBox)`
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const FilterButtonsLeft = styled(FlexBox)`
  justify-content: start;
  gap: 12px;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const RetakeCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  .common-checkbox {
    width: auto !important;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
    justify-content: flex-start;
    
    .common-checkbox {
      width: 100% !important;
    }
  }
`;

export const StyledResetButton = styled(RectangularButtonHollow)<{ height?: number }>`
  height: ${({ height }) => height ? `${height}px` : '48px'} !important;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const StyledApplyButton = styled(RectangularButtonFilled)<{ height?: number }>`
  height: ${({ height }) => height ? `${height}px` : '48px'} !important;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 100%;
  }
`;

export const TableContainer = styled.div`
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  overflow-y: visible;
  width: 100%;
  
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #F2F2F2;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #BFBFBF;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #A0A0A0;
  }
  
  scrollbar-width: thin;
  scrollbar-color: #BFBFBF #F2F2F2;
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background: #FFFFFF;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const TableHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #CDCDCD;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  color: #151514;
  white-space: nowrap;
  background: #F2F2F2;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableCell = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #E5E5E5;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #151514;
`;

export const GroupsTableCell = styled(TableCell)`
  max-width: 180px;
  width: 180px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  background: #99E599;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const GroupsTooltipStyle = styled.div`
  .groups-tooltip {
    background-color: #353A3E;
    color: #FEFEFE;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    line-height: 16px;
    max-width: 300px;
    z-index: 10000;
    
    div {
      color: #FEFEFE;
      margin-top: 4px;
      
      &:first-child {
        margin-top: 0;
      }
    }
  }
`;
